module.exports = __webpack_public_path__ + "img/gawaguchi_mo.95f02b89.jpg";